export default {
  // Page title
  'adsAgent.title': 'Agent Attribution Binding',

  // Search fields
  'adsAgent.dateRange': 'Operation Time',

  // Buttons
  'adsAgent.search': 'Search',
  'adsAgent.reset': 'Reset',
  'adsAgent.add': 'Add',
  'adsAgent.addAdsAgent': 'Add Agent Attribution Binding',
  'adsAgent.delete': 'Delete',
  'adsAgent.save': 'Save',
  'adsAgent.cancel': 'Cancel',

  // Table columns
  'adsAgent.serial': 'Serial',
  'adsAgent.agentNameChoose':'Agent Name',
  'adsAgent.adsName': 'Attribution Config Name',
  'adsAgent.agentName': 'Agent Name',
  'adsAgent.adsType': 'Attribution Channel',
  'adsAgent.operator': 'Operator',
  'adsAgent.operationTime': 'Operation Time',
  'adsAgent.action': 'Action',

  // Form labels
  'adsAgent.adsAccount': 'Attribution Config',

  // Form validation
  'adsAgent.agentNameRequired': 'Please select agent',
  'adsAgent.adsTypeRequired': 'Please select attribution channel',
  'adsAgent.adsAccountRequired': 'Please select attribution config',

  // Messages
  'adsAgent.addSuccess': 'Added successfully',
  'adsAgent.addFailed': 'Add failed',
  'adsAgent.deleteSuccess': 'Deleted successfully',
  'adsAgent.deleteFailed': 'Delete failed',
  'adsAgent.confirmDelete': 'Are you sure to delete this record?',
  'adsAgent.fetchTypesFailed': 'Failed to fetch attribution platform types',
  'adsAgent.fetchAdsAccountsFailed': 'Failed to fetch attribution configs',
  'adsAgent.fetchAgentsFailed': 'Failed to fetch agent list',

  // Pagination
  'adsAgent.totalRecords': 'Total {total} records',
  'adsAgent.pagination': 'Page {current} of {page}, Total {total} records',
};
